import { ClockPickerView } from "@mui/x-date-pickers";

export const shouldDisableTime = (
  timeValue: number,
  clockType: ClockPickerView
) => {
  if (clockType !== "hours") return false;
  return timeValue < 7 || timeValue > 19; // 7am-7:45pm
};
